import { useQuery, useSuspenseQuery } from '@tanstack/react-query'

import { API_ENDPOINTS } from '../../../common/apiEndpoints'
import { beneficiariesSchema } from '../../../common/validations'

import { get } from 'api/apiClient'

const params = (uuid: string) => ({
  queryKey: [`${API_ENDPOINTS.CONTRACTS}/${uuid}/beneficiaries`],
  queryFn: () =>
    get(
      `${API_ENDPOINTS.CONTRACTS}/${uuid}/beneficiaries`,
      beneficiariesSchema
    ),
})

export const useAPIGetContractBeneficiaries = (contractUUID: string) =>
  useQuery(params(contractUUID))

export const useAPIGetContractBeneficiariesSuspense = (contractUUID: string) =>
  useSuspenseQuery(params(contractUUID))
